import { type DesignDocument, designDocumentSchema } from '@repo/api-contracts';
import type { SaveErrorInfo } from './save-error';

export const INVALID_DESIGN_MESSAGE =
  '비어 있는 텍스트나 범위를 벗어난 값이 있습니다. 표시된 레이어를 확인해 주세요.';

/** 이슈 경로 ['components', i, 'layers', j, …] 가 가리키는 맨 위 레이어 id. 노드를 가리키지 않으면 null. */
const topLayerIdOf = (document: DesignDocument, path: readonly PropertyKey[]): string | null => {
  const [root, componentIndex, layersKey, layerIndex] = path;
  if (root !== 'components' || layersKey !== 'layers') return null;
  if (typeof componentIndex !== 'number' || typeof layerIndex !== 'number') return null;
  return document.components[componentIndex]?.layers[layerIndex]?.id ?? null;
};

/**
 * 저장 전 계약 검사(§6-5). 서버로 보내기 전에 빈 텍스트·범위 밖 값을 잡아 'invalid' 오류로 돌려준다.
 * ids 는 잘못된 값을 품은 맨 위 레이어 id 다(그룹 자식은 바깥 그룹 — 선택 단위와 같다).
 */
export const validateForSave = (document: DesignDocument): SaveErrorInfo | null => {
  const parsed = designDocumentSchema.safeParse(document);
  if (parsed.success) return null;
  const ids = new Set<string>();
  for (const issue of parsed.error.issues) {
    const id = topLayerIdOf(document, issue.path);
    if (id !== null) ids.add(id);
  }
  return { kind: 'invalid', ids: [...ids], message: INVALID_DESIGN_MESSAGE };
};
